<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-row :gutter="20">
      <el-col :sm="24" :md="12">
        <el-table stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell" />
          <el-table-column label="钱包名称" prop="walletName" min-width="150" />
          <el-table-column label="数量 / 金额" prop="amount" min-width="150" align="right">
            <template slot-scope="{row}"><span class="bold">{{ row.amount | filterPrice }}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="{row}">
              <el-button v-if="row.walletType === 16" type="text" @click="editWallet(row)">修改</el-button>
              <el-button v-if="row.walletType >=7 && row.walletType <= 16" type="text" @click="walletRecord(row)">记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col v-if="histories && histories.length" :sm="24" :md="12">
        <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
          <el-table v-sticky-header stripe fit :data="histories" header-cell-class-name="table-header-cell">
            <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell" />
            <el-table-column label="备注说明" prop="sourceName" min-width="150" />
            <el-table-column label="数量 / 金额" prop="amount" min-width="80" align="right">
              <template slot-scope="{row}"><span class="bold">{{ row.amount | filterPrice }}</span></template>
            </el-table-column>
            <el-table-column label="对应订单" prop="receiverId" min-width="150" />
          </el-table>
          <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchHistory" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCompaynWallet, getCompaynWalletRecords, saveCompaynWallet } from '@/api/finance'
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'

export default {
  name: 'FinanceCompany',
  components: { Pagination },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      histories: [],
      loading: false,
      queryParams: {
        walletType: '',
        page: 1,
        limit: 20
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      getCompaynWallet().then(response => {
        this.list = response
      }).catch(() => {})
    },
    editWallet(row) {
      this.histories = []
      this.$prompt(`当前金额数量为：<strong>${row.amount}</strong>`, '温馨提示', {
        confirmButtonText: '确定修改',
        cancelButtonText: '取 消',
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: '请输入正确的金额数量',
        dangerouslyUseHTMLString: true
      }).then(({ value }) => {
        row.amount = value
        saveCompaynWallet(row).then(() => {
          this.$message.success('数据保存成功')
        }).catch(() => {})
      }).catch(() => {})
    },
    walletRecord(row) {
      this.queryParams.page = 1
      this.queryParams.walletType = row.walletType
      this.fetchHistory()
    },
    fetchHistory() {
      this.loading = true
      getCompaynWalletRecords(this.queryParams).then(response => {
        this.histories = response.records
        this.total = response.total
      }).finally(() => {
        this.$util.delay().then(() => { this.loading = false })
      })
    }
  }
}
</script>
